import { createSlice } from "@reduxjs/toolkit";
import { reKyc_UpdateBankThunk } from "./thunk";

export const initialState = {
  reKyc_UpdateBankData: [],
  reKyc_UpdateBankError: "", // for error message
  reKyc_UpdateBankLoading: false,
};

const Re_Kyc_Update_Bank = createSlice({
  name: "Re_Kyc_Update_Bank",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(reKyc_UpdateBankThunk.pending, (state) => {
      state.reKyc_UpdateBankLoading = true;
      state.reKyc_UpdateBankData = [];
      state.reKyc_UpdateBankError = "";
    });
    builder.addCase(reKyc_UpdateBankThunk.fulfilled, (state, action) => {
      state.reKyc_UpdateBankData = action.payload.data;
      state.reKyc_UpdateBankLoading = false;
    });
    builder.addCase(reKyc_UpdateBankThunk.rejected, (state, action) => {
      state.reKyc_UpdateBankError =
        action.error?.message ||
        action.payload?.message ||
        "An unknown error occurred";
      state.reKyc_UpdateBankLoading = false;
    });
  },
});

export const { apiRequest, apiError } = Re_Kyc_Update_Bank.actions;

export default Re_Kyc_Update_Bank.reducer;
